import { useMemo } from 'react';
import ProgressiveImage from './ProgressiveImage';

function ProductGallery({ images = [], onSelect, activeImage }) {
  const items = useMemo(() => Array.isArray(images) ? images : [], [images]);

  if (!items.length) return null;

  return (
    <div className="product-gallery">
      <div className="product-gallery-thumbs">
        {items.map((image, index) => {
          const isActive = image === activeImage;
          return (
            <button
              key={`${image.name || index}-${index}`}
              type="button"
              className={`product-gallery-thumb${isActive ? ' is-active' : ''}`}
              onClick={() => {
                if (typeof onSelect === 'function') {
                  onSelect(image);
                }
              }}
            >
              <ProgressiveImage
                src={image.src}
                placeholder={image.preview?.src}
                alt={image.name || 'Product image'}
                className="product-gallery-thumb-image"
                wrapperClassName="product-gallery-thumb-wrapper"
              />
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ProductGallery;
